import { LocationHours } from 'js/components/LocationHours/index.js'
require('script-loader!node_modules/moment/moment.js');

class CustomHours extends LocationHours {
  constructor(element, opts) {
    super(element,opts);
    if (this.element.dataset.disableCustomHours) return;

    this.tbody = this.element.querySelector('tbody');
    if (this.tbody) {
      let rows = Array.from(this.element.querySelectorAll('.js-day-of-week-row'));
      this.days.forEach((day, dayIndex) => {
        day.weekDay = day.day;
        day.delta = dayIndex-this.todayIndex;
        day.order = day.delta >= 0 ? day.delta : 7+day.delta;
        day.isToday = dayIndex == this.todayIndex;
        day.date = moment()
                  .add(day.order, 'days')
                  .format('MMM D');
        let row = rows[dayIndex];
        row.order = day.order;
        row.parentNode.removeChild(row);
        let hoursColumn = row.querySelector('.c-location-hours-details-row-intervals');
        let dateColumn = document.createElement('td');
        dateColumn.innerText = day.date;
        row.insertBefore(dateColumn, hoursColumn);
      });
      rows.sort((a,b) => {
        // order less than 0 means move to the end in reverse order
        if (a.order < b.order) {
          return -1;
        }
        if (a.order > b.order) {
          return 1;
        }
        return 0;
      });
      rows.forEach((row) => {

        this.tbody.appendChild(row);
      });
    }
  }
}

export const Hours = CustomHours;
